import {
  HttpClient,
  HttpErrorResponse,
  HttpClientModule,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IContactInformation } from "../models/contactInformation.model";
import { BuildEnvironment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ContactInformationService {
  private baseURL =
    BuildEnvironment.GetEnvironmentUrl() + "/myprofile/contactInformation";
  constructor(private http: HttpClient) {}

  getAllContactInfo() {
    return this.http.get(this.baseURL + "/all");
  }

  getContactInfoById(id): Observable<any> {
    console.log("Inside service Id: ", id);
    // console.log("Value from the backend is: ", this.http.get(this.baseURL + "/getbyid/" + id));
    return this.http.get<any>(this.baseURL + "/getbyid/" + id);
    // try {
    //   return this.http.get(this.baseURL + "/getbyid/" + id);
    // } catch (err) {
    //   console.log("Error getting contact info by id: " + err);
    // }
  }

  getAgencyOnboardingStatus(agencyId): Observable<any> {
    return this.http.get(
      this.baseURL + "/getagencyonboardingstatus/" + agencyId
    );
  }

  public getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key =>
      formData.append(key, object[key] ? object[key] : "")
    );
    return formData;
  }

  updateContactInfo(contactinfodata, file) {
    try {
      console.log(contactinfodata);
      const formData = this.getFormData(contactinfodata);
      if (file) {
        formData.append("file", file, contactinfodata.newImgFileName);
      }
      console.log("Form Data: ", formData);
      return this.http.post(this.baseURL + "/update", formData);
    } catch (err) {
      console.log("Error updating contact info: " + err);
    }
  }

  downloadProfileImage(filename: string): Observable<any> {
    return this.http.get(this.baseURL + `/download/` + filename, {
      responseType: "blob"
    });
  }
}
